/**
 * The bytes behind a chosen file.
 *
 * `Blob.arrayBuffer()` is what every browser this product runs in offers, and it is used when
 * it is there. `FileReader` is the fallback, for two audiences: an older browser on a shop's
 * second-hand Android, and jsdom, whose `File` has no `arrayBuffer` at all — without this the
 * import screen would be the one part of the product no test could drive.
 */
export async function readFileBytes(file: File): Promise<Uint8Array> {
  if (typeof file.arrayBuffer === 'function') {
    return new Uint8Array(await file.arrayBuffer());
  }

  const buffer = await new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error('The file could not be read'));
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.readAsArrayBuffer(file);
  });
  return new Uint8Array(buffer);
}
